export const LEVELS = { beginner: "مبتدئ", intermediate: "متوسط", advanced: "متقدم" };
export const EQUIPMENT = { none: "بدون أدوات", dumbbells: "دمبل", bands: "مطاط مقاومة", mat: "سجادة", gym: "أجهزة نادي" };
export const MUSCLES = {
  full_body: "الجسم كامل", legs: "الأرجل", glutes: "الأرداف", core: "البطن", arms: "الذراعين",
  chest: "الصدر", back: "الظهر", shoulders: "الأكتاف", cardio: "كارديو", stretching: "إطالة",
};

export const fmtDuration = (sec) => {
  const s = Math.max(0, Math.round(sec || 0));
  if (!s) return "";
  if (s < 3600) return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
  return `${Math.floor(s / 3600)}:${String(Math.floor((s % 3600) / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
};

export const fmtMinutes = (sec) => {
  const m = Math.round((sec || 0) / 60);
  return m ? `${m} دقيقة` : "";
};
